import {Div} from '@quarks';
import styled from 'styled-components';

export const ModalCell = styled(Div)`
  background: ${({theme}) => theme.card.white.background};
  padding: calc(var(--padding-y) / 2) var(--padding-x);
  width: 100%;
`;
